function isRubricTask(result) {
  return Boolean(result?.is_rubric_task) || Boolean(result?.writingRubric)
    || ['transactional', 'essay'].includes(result?.kind)
    || /transactional|writing|essay|opstel|transaksioneel/i.test(result?.section || '');
}
function rubricCategory(step) {
  if (['format', 'content', 'language'].includes(step.category)) return step.category;
  const name = step.step || step.criterion || '';
  if (/content|inhoud|planning|beplanning/i.test(name)) return 'content';
  if (/language|taal|grammar|spelling|editing|style/i.test(name)) return 'language';
  if (/format|formaat|layout|structure|struktuur|organisation|paragraph/i.test(name)) return 'format';
  return 'content';
}
function getRubricBreakdown(result) {
  let rubric = result.writingRubric;
  if (!rubric && result.methodSteps?.length) {
    rubric = { deduction_reasons: result.feedback ? [result.feedback] : [] };
    for (const name of ['format', 'content', 'language']) { rubric[`${name}_score`] = 0; rubric[`${name}_max`] = 0; }
    for (const step of result.methodSteps) {
      const category = rubricCategory(step);
      rubric[`${category}_score`] += Number(step.marksAwarded) || 0;
      rubric[`${category}_max`] += Number(step.maxMarks) || 0;
    }
  }
  if (!rubric) return null;
  const sum = ['format', 'content', 'language'].reduce((total, key) => total + Number(rubric[`${key}_score`] || 0), 0);
  const maximum = ['format', 'content', 'language'].reduce((total, key) => total + Number(rubric[`${key}_max`] || 0), 0);
  return Math.abs(sum - Number(result.marksAwarded)) < .01 && Math.abs(maximum - Number(result.maxMarks)) < .01 ? rubric : null;
}
function buildRubricStamps(results, pageCount = Infinity) {
  return (results || []).filter(isRubricTask).map(result => {
    const rubric = getRubricBreakdown(result);
    const page = Math.min(pageCount, Math.max(1, Number(result.evidencePage) || 1));
    const format = value => Number.isInteger(Number(value)) ? String(Number(value)) : Number(value).toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    const categories = ['format', 'content', 'language'];
    const scores = rubric ? categories.map(key => `${key[0].toUpperCase()}${key.slice(1)}: ${format(rubric[`${key}_score`])}/${format(rubric[`${key}_max`])}`).join(' | ') : '';
    const pending = Boolean(rubric?.pendingCriteria?.length) || (result.methodSteps || []).some(step => step.status === 'needs_evidence');
    const total = `${pending ? 'PROVISIONAL ASSESSED TOTAL' : 'TOTAL'}: ${format(result.marksAwarded)}/${format(result.maxMarks)}`;
    const reasons = rubric?.deduction_reasons?.length ? rubric.deduction_reasons.join('; ')
      : Number(result.marksAwarded) === Number(result.maxMarks) ? 'All rubric requirements met.' : result.feedback || 'See teacher-reviewed scoring breakdown.';
    const top = Number(result.answerBox?.y) || .12;
    const height = Number(result.answerBox?.height) || .7;
    return { result, page, title: `Examiner rubric - Question ${result.questionNumber}`,
      scoreLine: pending ? `${total} - rubric evidence review pending` : scores ? `${scores}  =>  ${total}` : total,
      deductionLine: pending ? `Review required: ${reasons}` : Number(result.marksAwarded) === Number(result.maxMarks) ? reasons : `Deductions: ${reasons}`,
      ticks: categories.map((category, index) => ({
        x: 1.02, y: Math.min(.95, top + height * [.08, .5, .92][index]),
        lost: rubric ? Number(rubric[`${category}_score`]) < Number(rubric[`${category}_max`]) : Number(result.marksAwarded) < Number(result.maxMarks),
      })),
    };
  });
}
module.exports = { isRubricTask, getRubricBreakdown, buildRubricStamps };
